import { createReducer } from '@reduxjs/toolkit';
import { LocalStorage } from '../../shared/utils';
import { reducer as downgrade } from './downgrade';
import { reducer as fetchProducts } from './fetchProducts';
import { reducer as fetchInvoices } from './fetchInvoices';
import { reducer as selectPlan } from './selectPlan';
import { reducer as selectFeature } from './selectFeature';
import { reducer as getCustomAddonsFromSubscription } from './getCustomAddonsFromSubscription';
import { reducer as setUpdatePlanBannerState } from './setUpdatePlanBannerState';
import { reducer as setUpdateAiTierBannerState } from './setUpdateAiTierBannerState';

const initialState = {
  loading: false,
  downgrading: false,
  error: false,
  data: {
    plans: [],
  },
  customAddonsFromSubscription: [],
  invoices: null,
  invoicesLoading: false,
  invoicesError: false,
  isUpdatePlanBannerHidden: LocalStorage.get('isUpdatePlanBannerHidden'),
  isUpdateAiTierBannerHidden: LocalStorage.get('isUpdateAiTierBannerHidden'),
};

const billingReducer = createReducer(
  initialState,
  (builder) => {
    setUpdatePlanBannerState(builder);

    setUpdateAiTierBannerState(builder);

    downgrade(builder);

    fetchProducts(builder);

    fetchInvoices(builder);

    selectPlan(builder);

    selectFeature(builder);

    getCustomAddonsFromSubscription(builder);
  },
);

export default billingReducer;
